// extracted by mini-css-extract-plugin
export default {"home":"TaskListPage-styles-module--home--gpjDG"};